
<div class="multipleLikeViewButton">
  <a href="/checklist/" class="ui button"><i class="icon bookmark outline"></i>問合せリストを確認する</a>
  <div v-if="$root.selectedShopCount > 0" class="ui floating circular label">{{ $root.selectedShopCount }}</div>
</div>
